import { createContext } from "react";
import { useState } from "react";

const FileKeysContext = createContext({
  multipleImagesTempKeys: [],
  multipleImagesKeys: [],
  singleDocTempKey: '',
  singleDocKey: '',
  featuredImageTempKey: '',
  featuredImageKey: '',
  videoTempKey: '',
  videoKey: '',
  videoCoverTempKey: '',
  videoCoverKey: '',
  multipleVideosTempKeys: [],
  multipleVideosKeys: [],
  newOldKeys: [],
  newOldVideoCoverKey: '',
  newOldFeaturedImageKey: '',
  newOldDocumentKey: '',
  expertPageCoverTempKey: '',
  expertPageCoverKey: '',
  expertAvatarTempKey: '',
  expertAvatarKey: '',
  shopImagesTempKeys: [],
  shopImagesKeys: [],
});

export const FileKeysProvider = ({ children }) => {
  const [multipleImagesTempKeys, setmultipleImagesTempKeys] = useState([]);
  const [multipleImagesKeys, setMultipleImagesKeys] = useState([]);
  const [singleDocTempKey, setSingleDocTempKey] = useState('');
  const [singleDocKey, setSingleDocKey] = useState('');
  const [featuredImageTempKey, setFeaturedImageTempKey] = useState('');
  const [featuredImageKey, setFeaturedImageKey] = useState('');
  const [videoTempKey, setVideoTempKey] = useState('');
  const [videoKey, setVideoKey] = useState('');
  const [videoCoverTempKey, setVideoCoverTempKey] = useState('');
  const [videoCoverKey, setVideoCoverKey] = useState('');
  const [multipleVideosTempKeys, setMultipleVideosTempKeys] = useState([]);
  const [multipleVideosKeys, setMultipleVideosKeys] = useState([]);
  const [newOldKeys, setNewOldKeys] = useState([]);
  const [newOldVideoCoverKey, setNewOldVideoCoverKey] = useState('');
  const [newOldFeaturedImageKey, setNewOldFeaturedImageKey] = useState('');
  const [newOldDocumentKey, setNewOldDocumentKey] = useState('');
  const [expertPageCoverTempKey, setExpertPageCoverTempKey] = useState('')
  const [expertPageCoverKey, setExpertPageCoverKey] = useState('');
  const [expertAvatarTempKey, setExpertAvatarTempKey] = useState('')
  const [expertAvatarKey, setExpertAvatarKey] = useState('');
  const [shopImagesTempKeys, setShopImagesTempKeys] = useState([])
  const [shopImagesKeys, setShopImagesKeys] = useState([]);


  const multipleImagesTempKeysAction = (data) => {
    setmultipleImagesTempKeys(data);
  };

  const multipleImagesKeysAction = (data) => {
    setMultipleImagesKeys(data);
  };

  const singleDocTempKeyAction = (data) => {
    setSingleDocTempKey(data);
  };

  const singleDocKeyAction = (data) => {
    setSingleDocKey(data);
  };

  const featuredImageTempKeyAction = (data) => {
    setFeaturedImageTempKey(data);
  };

  const featuredImageKeyAction = (data) => {
    setFeaturedImageKey(data);
  };
  
  const videoTempKeyAction = (data) => {
    setVideoTempKey(data);
  };

  const videoKeyAction = (data) => {
    setVideoKey(data);
  };

  const videoCoverTempKeyAction = (data) => {
    setVideoCoverTempKey(data);
  };

  const videoCoverKeyAction = (data) => {
    setVideoCoverKey(data);
  };

  const multipleVideosTempKeysAction = (data) => {
    setMultipleVideosTempKeys(data)
  }

  const multipleVideosKeysAction = (data) => {
    setMultipleVideosKeys(data)
  }

  const newOldKeysAction = (data) => {
    setNewOldKeys(data);
  };

  const newOldVideoCoverKeyAction = (data) => {
    setNewOldVideoCoverKey(data);
  };

  const newOldFeaturedImageKeyAction = (data) => {
    setNewOldFeaturedImageKey(data);
  };

  const newOldDocumentKeyAction = (data) => {
    setNewOldDocumentKey(data);
  };

  const expertPageCoverTempKeyAction = (data) => {
    setExpertPageCoverTempKey(data);
  };

  const expertPageCoverKeyAction = (data) => {
    setExpertPageCoverKey(data);
  };

  const expertAvatarTempKeyAction = (data) => {
    setExpertAvatarTempKey(data);
  };

  const expertAvatarKeyAction = (data) => {
    setExpertAvatarKey(data);
  };

  const shopImagesTempKeyAction = (data) => {
    setShopImagesTempKeys(data);
  };

  const shopImagesKeysAction = (data) => {
    setShopImagesKeys(data);
  };

  const resetFileKeysContext = () => {
    setmultipleImagesTempKeys([])
    setMultipleImagesKeys([])
    setSingleDocTempKey('')
    setSingleDocKey('')
    setFeaturedImageTempKey('')
    setFeaturedImageKey('')
    setVideoTempKey('')
    setVideoKey('')
    setVideoCoverTempKey('')
    setVideoCoverKey('')
    setMultipleVideosTempKeys([])
    setMultipleVideosKeys([])
    setNewOldKeys([]);
    setNewOldVideoCoverKey('');
    setNewOldFeaturedImageKey('');
    setNewOldDocumentKey('');
    setExpertPageCoverTempKey('');
    setExpertPageCoverKey('');
    setExpertAvatarTempKey('');
    setExpertAvatarKey('');
    setShopImagesTempKeys([]);
    setShopImagesKeys([]);
  };

  return (
    <FileKeysContext.Provider
      value={{
        multipleImagesTempKeys,
        multipleImagesKeys,
        multipleImagesTempKeysAction,
        multipleImagesKeysAction,
        singleDocTempKey,
        singleDocKey,
        singleDocTempKeyAction,
        singleDocKeyAction,
        featuredImageTempKey,
        featuredImageKey,
        featuredImageTempKeyAction,
        featuredImageKeyAction,
        videoTempKey,
        videoKey,
        videoTempKeyAction,
        videoKeyAction,
        videoCoverTempKey,
        videoCoverKey,
        videoCoverTempKeyAction,
        videoCoverKeyAction,
        multipleVideosTempKeys,
        multipleVideosKeys,
        multipleVideosTempKeysAction,
        multipleVideosKeysAction,
        newOldKeys,
        newOldKeysAction,
        newOldVideoCoverKey,
        newOldVideoCoverKeyAction,
        newOldFeaturedImageKey,
        newOldFeaturedImageKeyAction,
        newOldDocumentKey,
        newOldDocumentKeyAction,
        expertPageCoverTempKey,
        expertPageCoverKey,
        expertPageCoverTempKeyAction,
        expertPageCoverKeyAction,
        expertAvatarTempKey,
        expertAvatarKey,
        expertAvatarTempKeyAction,
        expertAvatarKeyAction,
        shopImagesTempKeys,
        shopImagesKeys,
        shopImagesTempKeyAction,
        shopImagesKeysAction,
        resetFileKeysContext,
      }}
    >
      {children}
    </FileKeysContext.Provider>
  );
};

export default FileKeysContext;
